var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyBtc = function SvgIconCurrencyBtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.375 1.25a1 1 0 0 1 1 1V3.5h1.75V2.25a1 1 0 1 1 2 0v1.366a4.375 4.375 0 0 1 2.282 7.152 4.75 4.75 0 0 1-2.157 8.982h-.125V21a1 1 0 1 1-2 0v-1.25h-1.75V21a1 1 0 1 1-2 0v-1.25H6a1 1 0 1 1 0-2h.5V5.5H6a1 1 0 0 1 0-2h2.375V2.25a1 1 0 0 1 1-1m4.875 16.5a2.75 2.75 0 1 0 0-5.5H8.5v5.5zM13.125 5.5H8.5v4.75h4.625a2.375 2.375 0 1 0 0-4.75",
    clipRule: "evenodd"
  })));
};
export default SvgIconCurrencyBtc;